import { Card, Col, Row } from 'react-bootstrap';
import Counter from './Step.Counter';
import Title from './Step.Title';
import Result from './Step.Result';

/**
 * Status displays an individual step Counter, Title, and final result status.
 *
 */
const Status = (props) => {
  const {
    active, children, completed, index, pending, title,
  } = props;

  return (
    <Card.Header className="stepper__step--vertical" bsPrefix>
      <Row>
        <Col md="auto"><Counter {...{ active, pending, index }} /></Col>
        <Col md={7}><Title {...{ pending, title }} /></Col>
        <Col md={4} style={{ textAlign: 'right' }}>
          {completed && children
          && (
          <Result>
            {children}
          </Result>
          )}
        </Col>
      </Row>
    </Card.Header>
  );
};

export default Status;
